import axios from 'axios';
import catchify from 'catchify';
import { SUBSCRIBE_URL } from '@/constants/global';
import { isValidEmail } from '../util/global';

export default {
  data() {
    return {
      emailAddress: this.user?.email || '',
      isProcessing: false,
      isEmailSubmitted: false,
      utmSource: '',
      utmCampaign: '',
      utmMedium: '',
      utmContent: 'AppSumo Nuxt Email Form',
    };
  },
  mounted() {
    this.utmSource = this.$route?.query.utm_source || this.$cookies?.get('utm_source');
    this.utmCampaign = this.$route?.query.utm_campaign || this.$cookies?.get('utm_campaign');
    this.utmMedium = this.$route?.query.utm_medium || this.$cookies?.get('utm_medium');
    // this.$options.name is unavailable here. So we use the private _componentTag
    // eslint-disable-next-line no-underscore-dangle
    if (this.$options._componentTag) {
      // eslint-disable-next-line no-underscore-dangle
      this.utmContent = this.$options._componentTag;
    }
  },
  computed: {
    isEmailAddressValid() {
      return isValidEmail(this.emailAddress);
    },
  },
  methods: {
    $_formHeaders() {
      // an: request CSRF token every time in case a login is detected from another tab
      return {
        headers: {
          'X-CSRFToken': this.$cookies?.get('csrftoken'),
          'Content-Type': 'multipart/form-data',
        },
      };
    },
    $_createFormDataWithUtm() {
      const formData = new FormData();
      const utmQueryParams = [
        { name: 'source', value: this.utmSource },
        { name: 'campaign', value: this.utmCampaign },
        { name: 'medium', value: this.utmMedium },
        { name: 'content', value: this.utmContent },
      ];
      utmQueryParams.forEach((paramObj) => {
        if (paramObj.value) {
          formData.append(paramObj.name, paramObj.value);
        }
      });

      return formData;
    },
    $_validateEmail(email) {
      return isValidEmail(email);
    },
    async $_asyncSubmitEmail(allowDuplicate = true) {
      if (!this.isEmailAddressValid) {
        this.$toastr.w('Please use a valid email address.');
        return;
      }

      const formData = this.$_createFormDataWithUtm();
      formData.append('email', this.emailAddress);
      formData.append('allow_duplicate', allowDuplicate);

      await this.$_sendEmailRequest(SUBSCRIBE_URL, formData);
    },
    gtag(event) {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push(event);
    },
    async $_sendEmailRequest(url, formData, showToastMessage = true) {
      this.isProcessing = true;

      const [error, res] = await catchify(
        axios.post(url, formData, this.$_formHeaders()),
      );

      if (error || !res) {
        this.$toastr.e('Something has gone wrong with this request. Please try again.');
      } else {
        const { data, status } = res;

        if (status === 200) {
          if (showToastMessage) {
            const successToast = data?.message
              || 'You\'re signed up to receive the hottest deals, straight into your inbox!';

            this.$toastr.s(successToast);
          }

          // https://www.analyticsmania.com/post/google-tag-manager-custom-event-trigger/
          if (data?.email_subscribed) {
            this.gtag({
              event: 'email-subscribed',
              content: formData.get('content'),
              email: formData.get('email'),
            });
          }
          this.isEmailSubmitted = true;
          this.$emit('email-submitted');
        } else if (status === 205) {
          this.$toastr.e(
            'Email already registered. Please login or use a different email and try again.',
          );
        }
      }

      this.isProcessing = false;

      return error;
    },
  },
};
